import React, { ButtonHTMLAttributes, FC } from 'react';
import PlainButtonStyled from './PlainButtonStyled';
interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'large' | 'medium' | 'small';
  disabled?: boolean;
  children?: JSX.Element[] | JSX.Element | string;
  icon?: JSX.Element;
}
const PlainButton: FC<Props> = ({ children, className, disabled, size, icon, ...props }) => {
  return (
    <PlainButtonStyled customClass={className} size={size} disabled={disabled} {...props}>
      {icon && icon}
      <span>{children}</span>
    </PlainButtonStyled>
  );
};

PlainButton.defaultProps = {
  children: '',
  className: '',
  disabled: false,
};

PlainButton.displayName = 'PlainButton';

export default PlainButton;
